import { ObjectValues } from "@/src/shared/types/objectValues";

export const DS_PROGRESS_BAR_VARIANT = {
  Primary: "primary",
  Secondary: "secondary",
  Success: "success",
  Danger: "danger",
  Info: "info",
} as const;

export type DSProgressBarVariant = ObjectValues<typeof DS_PROGRESS_BAR_VARIANT>;
